
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    export class PromoDayDialog extends Serenity.EntityDialog<PromoDayRow, any> {
        protected getFormKey() { return PromoDayForm.formKey; }
        protected getIdProperty() { return PromoDayRow.idProperty; }
        protected getLocalTextPrefix() { return PromoDayRow.localTextPrefix; }
        protected getNameProperty() { return PromoDayRow.nameProperty; }
        protected getService() { return PromoDayService.baseUrl; }
        protected getDeletePermission() { return PromoDayRow.deletePermission; }
        protected getInsertPermission() { return PromoDayRow.insertPermission; }
        protected getUpdatePermission() { return PromoDayRow.updatePermission; }

        protected form = new PromoDayForm(this.idPrefix);

    }
}